import { apiGetSuppliers, apiGetSuppliersSummary, apiGetMore } from '@/api';
import * as types from '@/store/mutation-types';

// Models
import PAGINATION from '@/store/models/pagination';

// initial state
const state = {
  all: {
    data: [],
    meta: PAGINATION
  },

  summary: []
};

// mutations
const mutations = {
  [types.RECEIVED_SUPPLIERS] (state, suppliers) {
    state.all = suppliers
  },

  [types.APPEND_SUPPLIERS] (state, suppliers) {
    state.suppliers.data.push(...suppliers.data);
    state.suppliers.meta = suppliers.meta;
  },

  [types.RECEIVED_SUPPLIERS_SUMMARY] (state, suppliers) {
    state.summary = suppliers.data
  },
};

const actions = {
  getSuppliers: ({ commit }) => {
    return apiGetSuppliers({ include: 'stats', is_active: true })
      .then(({ data }) => commit(types.RECEIVED_SUPPLIERS, data))
      .catch((error) => console.log(error));
  },

  getMoreSuppliers: ({ commit }, url) => {
    return apiGetMore(url)
      .then(({ data }) => commit(types.APPEND_SUPPLIERS, data))
      .catch((error) => console.log(error));
  },

  getSuppliersSummary: ({ commit }) => {
    return apiGetSuppliersSummary({ is_active: true })
      .then(({ data }) => commit(types.RECEIVED_SUPPLIERS_SUMMARY, data))
      .catch((error) => console.log(error));
  },
};

const getters = {
  suppliers (state) {
    return state.all;
  },

  suppliersSummary () {
    return state.summary;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/modules/suppliers.js